import React, { useState } from "react";
import Modal from "react-awesome-modal";
import { useHistory } from "react-router-dom";
import {
  Box,
  Button,
  OutlinedInput,
  InputLabel,
  Grid,
  FormGroup,
  FormControlLabel,
  Checkbox,
  DialogTitle,
  Typography,
  DialogContent,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { backend } from "../../../api";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import AgreementDoc from "../../../components/common/AgreementDoc";
import TermsDoc from "../../../components/common/TermsDoc";

const useStyles = makeStyles((theme) => ({
  cancelModalBtn: {
    backgroundColor: theme.palette.error.main,
    color: "white",
    "&:hover": {
      backgroundColor: theme.palette.error.dark,
    },
    width: 100,
  },
  btn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    minWidth: "110px",
    margin: "10px 0",
    float: "right",
    fontSize: "16px",
    height: "100%",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 10px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
  infoDesc: {
    fontSize: "18px",
    textAlign: "justify",
    fontWeight: 400,
    lineHeight: "36px",
    [theme.breakpoints.down("md")]: {
      fontSize: "24px",
      lineHeight: "30px",
    },
  },
  updateModalBtn: {
    backgroundColor: theme.palette.warning.light,
    color: "white",
    "&:hover": {
      backgroundColor: theme.palette.warning.main,
    },
    width: 100,
  },
  contentContainer: {
    maxHeight: "400px", // Limit the height
    overflowY: "auto", // Add scroll for overflow content
    padding: "0 16px", // Add padding inside the scrollable area
  },
}));
const error = "Please agree to the terms and conditions to continue ";
function RegisterModal(props) {
  const [checked, setChecked] = React.useState(false);
  const history = useHistory();
  const [err, setErr] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const { visible, closeModal } = props;

  const classes = useStyles();
  const handleBackToHome = () => {
    history.push("/");
  };
  const handler = () => {
    if (checked == true) {
      props.closeModal();
    } else {
      setErr(true);
    }
  };

  return (
    <Modal visible={visible} width="600" effect="fadeInUp" disableBackdropClick>
      <div className="modal-container">
        <br />
        <DialogTitle color="primary">Agreement</DialogTitle>

        <hr className="modal-line" />
        <DialogContent className={classes.contentContainer}>
          <DialogContentText
            id="alert-dialog-slide-description"
            className={classes.infoDesc}
          >
            {/* <AgreementDoc /> */}
            <TermsDoc/>
          </DialogContentText>
          <FormGroup>
            <FormControlLabel
              control={<Checkbox checked={checked} onChange={handleChange} />}
              label="I agree to following terms."
            />
            {err && (
              <Typography variant="subtitle2" color="error">
                {error}
              </Typography>
            )}
          </FormGroup>
          <Button
            className={classes.btn}
            style={{ marginLeft: "20px" }}
            onClick={handleBackToHome}
          >
            Back to Home
          </Button>
          <Button className={classes.btn} onClick={() => handler()}>
            Submit
          </Button>
        </DialogContent>
      </div>
    </Modal>
  );
}

export default RegisterModal;
